import { useEffect, useState } from "react";

const useCounterAnimation = (targetValue: number, maxDuration: number = 1000) => {
  const [value, setValue] = useState<number>(0);

  useEffect(() => {
    if (0 === targetValue) {
      setValue(0);

      return;
    }

    const step = Math.max(1, Math.floor(targetValue / (maxDuration / 10)));
    let start = 0;
    const stepTime = maxDuration / (targetValue / step);

    const timer = setInterval(() => {
      start = Math.min(start + step, targetValue);
      setValue(start);

      if (start >= targetValue) {
        clearInterval(timer);
      }
    }, stepTime);

    return () => clearInterval(timer);
  }, [targetValue, maxDuration])

  return value;
};

export default useCounterAnimation;
